export const initSectionWhenUserInteracts = (targetElement, callback) => {
  if (!targetElement || !callback) return;

  const setEventListener = (eventName, callbackFn) => {
    document.addEventListener(
      eventName,
      () => {
        callbackFn();
      },
      { once: true },
    );
  };

  setEventListener('mousemove', callback);
  setEventListener('touchstart', callback);
};
